export default __webpack_public_path__ + "static/media/ECE-graf-PLA-FLEXA3-cat-6.797dd7bc.png";